import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesDogComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="11" cy="4" fill="none" r="2" />
        <circle cx="18" cy="8" fill="none" r="2" />
        <circle cx="20" cy="16" fill="none" r="2" />
        <path
          d="M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"
          fill="none"
        />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesDogComponent.displayName = 'IconAmenitiesDog';

const IconAmenitiesDog = React.memo(IconAmenitiesDogComponent);

export default IconAmenitiesDog;
